"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/audit/hooks");
var WizardParts_1 = require("./WizardParts");
var RequestAudit = function () {
    var _a = __read((0, hooks_1.useRequestAudit)('Welcome Flow'), 3), requestAudit = _a[0], isRequestingAudit = _a[1], hasRequestedSaasAudit = _a[2];
    return ((0, jsx_runtime_1.jsx)(WizardParts_1.StepTemplate, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", width: "100%" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Are you overspending on software?" })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, sx: { my: 3 } }, { children: ["Our SaaS audit helps you get more for less. Understand SaaS usage, identify saving opportunities, and receive a tailored SaaS forecasting report. You\u2019ll see how small changes compound into ", (0, jsx_runtime_1.jsx)("b", { children: "big savings" }), "."] })), !hasRequestedSaasAudit && ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "secondary", disabled: isRequestingAudit, onClick: requestAudit, size: "large", sx: { color: 'common.white', fontWeight: 600 } }, { children: "Request an audit" }))), hasRequestedSaasAudit && ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ mt: 2, display: "inline-flex", flexDirection: "column", alignItems: "flex-start" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "Thank you! In the meanwhile, get in touch with us to understand better how you manage your stack." })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ href: "https://meetings.hubspot.com/alexhudled/meeting", targetUrl: "_blank", sx: { my: 2 } }, { children: "Book a meeting with us" }))] })))] }) })) }));
};
exports.default = RequestAudit;
